"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseChargeTokenResponse = exports.createChargeTokenResponse = void 0;
const decodeFromBase64_1 = require("@wix/cashier-common/dist/src/utils/decodeFromBase64");
const encodeToBase64_1 = require("@wix/cashier-common/dist/src/utils/encodeToBase64");
const createChargeTokenResponse = (chargeResponse) => {
    return (0, encodeToBase64_1.encodeToBase64)(JSON.stringify(chargeResponse));
};
exports.createChargeTokenResponse = createChargeTokenResponse;
const parseChargeTokenResponse = (chargeResponseToken) => {
    try {
        return JSON.parse((0, decodeFromBase64_1.decodeFromBase64)(chargeResponseToken));
    }
    catch (error) {
        throw new Error(`Failed to parse response token: ${error.message}`);
    }
};
exports.parseChargeTokenResponse = parseChargeTokenResponse;
//# sourceMappingURL=chargeTokenResponseUtils.js.map